if( document.querySelector( 'section.small-hero' ) ) {
    var smallHero = {
        button: document.querySelector( 'section.small-hero .button-container' ),
        clickHandler: function( event ) {
            event.preventDefault();
            var container = event.srcElement.closest( 'section' );
            var yPosition = container.scrollTop + container.clientHeight;
            if( container.clientWidth < 1024 ) {
                yPosition = yPosition - 100;
            } else {
                yPosition = yPosition + container.offsetTop;
            }
            window.scrollTo({
                top: yPosition,
                left: 0,
                behavior: "smooth"
              });
            return false;
        },
        init: function() {
            smallHero.button.addEventListener( 'click', smallHero.clickHandler );
            return;
        }
    };
    smallHero.init();
}
